<template>
  <div>
      <div class="container">
        <div class="form">
          <div class="boite">
            <input
              type="radio"
              id="boite-bm"
              name="boite"
              value="BM"
              @change="boiteChoice"
              :checked="moniteur.boite === 'BM'"
            />
            <label for="boite-bm">BM</label>
            <input
              type="radio"
              id="boite-ba"
              name="boite"
              value="BA"
              @change="boiteChoice"
              :checked="moniteur.boite === 'BA'"
            />
            <label for="boite-ba">BA</label>
          </div>

          <div class="field">
            <label class="labelForm">Nom</label>
            <input
              type="text"
              class="form-control inputsize"
              placeholder="Nom"
              v-model="moniteur.nom"
            />
          </div>

          <div class="row">
            <div class="field">
              <label class="labelForm">Prénom</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="Prénom"
                v-model="moniteur.prenom"
              />
            </div>
            <div class="field">
              <label class="labelForm">Surnom (Jean David = JED)</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="Surnom"
                v-model="moniteur.surnom"
              />
            </div>
          </div>

          <div class="field">
            <label class="labelForm">Adresse</label>
            <input
              type="text"
              class="form-control inputsize"
              placeholder="Adresse"
              v-model="moniteur.adresse"
            />
          </div>

          <div class="row">
            <div class="field">
              <label class="labelForm">Code postal</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="CP"
                v-model="moniteur.cp"
              />
            </div>
            <div class="field">
              <label class="labelForm">Ville</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="Ville"
                v-model="moniteur.ville"
              />
            </div>
          </div>

          <div class="row">
            <div class="field">
              <label class="labelForm">Email</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="Email"
                v-model="moniteur.mail"
              />
            </div>
            <div class="field">
              <label class="labelForm">Téléphone</label>
              <input
                type="text"
                class="form-control inputsize"
                placeholder="Téléphone"
                v-model="moniteur.tel"
              />
            </div>
          </div>
          <div class="choixlieu">
            <div class="groupe">
              <template
                v-for="i in this.$store.state.groupeLieuPlanning"
                :key="i"
              >
                <template v-if="i != 4">
                  <template v-if="this.groupeSelect == i">
                    <button
                      class="btnGroupe btn-primary"
                      @click="groupeChoice(i)"
                    >
                      Groupe {{ i }}
                    </button>
                  </template>
                  <template v-else>
                    <button
                      class="btnGroupe btn-secondary"
                      @click="groupeChoice(i)"
                    >
                      Groupe {{ i }}
                    </button>
                  </template>
                </template>
              </template>
            </div>
            <div class="table">
              <DataTable :value="lieuxMono" v-if="groupeSelect == 1">
                <Column field="nom" header="Nom">
                  <template #body="{ data }">
                    <p :title="data.fulladresse">{{ data.nom }}</p>
                  </template>
                </Column>
                <Column field="Input" header="Input">
                  <template #body="{ data }">
                    <template v-if="this.moniteurEdits != null">
                      <template v-if="groupeSelect == data.groupe">
                        <template v-if="data.get">
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                            checked
                          />
                        </template>
                        <template v-else>
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                          />
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <input
                          type="checkbox"
                          :name="data.id"
                          :id="data.id"
                          @change="lieuChoice"
                        />
                    </template>
                  </template>
                </Column>
              </DataTable>

              <DataTable :value="lieuxMono" v-if="groupeSelect == 2">
                <Column field="nom" header="Nom">
                  <template #body="{ data }">
                    <p :title="data.fulladresse">{{ data.nom }}</p>
                  </template>
                </Column>
                <Column field="Input" header="Input">
                  <template #body="{ data }">
                    <template v-if="this.moniteurEdits != null">
                      <template v-if="groupeSelect == data.groupe">
                        <template v-if="data.get">
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                            checked
                          />
                        </template>
                        <template v-else>
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                          />
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <input
                          type="checkbox"
                          :name="data.id"
                          :id="data.id"
                          @change="lieuChoice"
                        />
                    </template>
                  </template>
                </Column>
              </DataTable>

              <DataTable :value="lieuxMono" v-if="groupeSelect == 3">
                <Column field="nom" header="Nom">
                  <template #body="{ data }">
                    <p :title="data.fulladresse">{{ data.nom }}</p>
                  </template>
                </Column>
                <Column field="Input" header="Input">
                  <template #body="{ data }">
                    <template v-if="this.moniteurEdits != null">
                      <template v-if="groupeSelect == data.groupe">
                        <template v-if="data.get">
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                            checked
                          />
                        </template>
                        <template v-else>
                          <input
                            type="checkbox"
                            :name="data.id"
                            :id="data.id"
                            @change="lieuChoice"
                          />
                        </template>
                      </template>
                    </template>
                    <template v-else>
                      <input
                          type="checkbox"
                          :name="data.id"
                          :id="data.id"
                          @change="lieuChoice"
                        />
                    </template>
                  </template>
                </Column>
              </DataTable>


            </div>
          </div>
        </div>
      </div>
      <button @click="setMono" class="btn btn-primary">VALIDER</button>
  </div>
</template>

<script>
export default {

  props: [
    "visible",
    "moniteurs",
    "monoChecked",
    "moniteurEdits",
    "showEditMonoReset",
    "getAllMoniteurs",
    "cancelModal"
  ],

  watch: {
    visibles: function () {
      if (this.visibles == false) {
        this.$emit("showEditMonoReset");
      }
    },
  },
  data() {
    return {
      visibles: false,
      moniteur: {
        nom: "",
        prenom: "",
        surnom: "",
        adresse: "",
        cp: "",
        ville: "",
        mail: "",
        tel: "",
        boite: "",
        lieux: [],
        groupe: 0,
      },
      header: "Nouveau Moniteur",
      moniteurEdit: null,
      lieuxMono: [],
      groupeSelect: 1,
      LieuxChoiceMono: [],
      originalBoite: null,
    };
  },

  mounted() {
    this.visibles = this.visible;
    
    this.$store.commit("setChoiceBoitePlanning", null);

    if (this.moniteurEdits != null) {
      this.header = this.moniteurEdits.fullname;
      this.moniteur = {
        nom: this.moniteurEdits.nom,
        prenom: this.moniteurEdits.prenom,
        surnom: this.moniteurEdits.surnom,
        adresse: this.moniteurEdits.adresse.adresse,
        cp: this.moniteurEdits.adresse.cp,
        ville: this.moniteurEdits.adresse.ville,
        mail: this.moniteurEdits.email,
        tel: this.moniteurEdits.telephone,
        boite: this.moniteurEdits.boite === "BA,BM" ? "BM" : this.moniteurEdits.boite,
        lieux: this.moniteurEdits.lieux,
        groupe: this.moniteurEdits.groupeLieu,
      };
      this.originalBoite = this.moniteur.boite;

      this.lieuxMono = this.moniteur.lieux.filter((e) => e.groupe == 1);
      let lieuget = this.moniteur.lieux.filter((e) => e.get == true);
      lieuget.forEach((e) => {
        this.LieuxChoiceMono.push(e.id);
      });
      
      this.$store.commit("setRdvBoite", this.moniteurEdits.rdvs);

    } else {
      this.lieuxMono = this.$store.state.lieuxMonosPlanning.filter(
        (e) => e.groupe == 1
      );
      this.moniteur = {
        nom: "",
        prenom: "",
        surnom: "",
        adresse: "",
        cp: "",
        ville: "",
        mail: "",
        tel: "",
        boite: "",
        lieux: [],
        groupe: 0,
      };

    }
  },

  methods: {
    setMono() {
      if(this.moniteurEdits == null){
        window.api
        .post(
          "/set/moniteurs",
          {
            nom: this.moniteur.nom,
            prenom: this.moniteur.prenom,
            surnom: this.moniteur.surnom,
            adresse: this.moniteur.adresse,
            cp: this.moniteur.cp,
            ville: this.moniteur.ville,
            mail: this.moniteur.mail,
            tel: this.moniteur.tel,
            boite: this.moniteur.boite,
            lieux: this.LieuxChoiceMono,
            agenceId: this.$store.state.user.agence.id,
            rdvs: this.$store.state.rdvBoite
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          this.$emit("getAllMoniteurs");
          this.$emit("cancelModal");
          //window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.data && error.response.data.errors) {
            alert(error.response.data.errors.join("\n"));
          } else if(error.response.data === "Infos manquantes"){
            alert("Infos manquantes")
          }
        });
      }else{
        window.api
        .put(
          "/edit/moniteurs/"+this.moniteurEdits.id,
          {
            nom: this.moniteur.nom,
            prenom: this.moniteur.prenom,
            surnom: this.moniteur.surnom,
            adresse: this.moniteur.adresse,
            cp: this.moniteur.cp,
            ville: this.moniteur.ville,
            mail: this.moniteur.mail,
            tel: this.moniteur.tel,
            boite: this.moniteur.boite,
            lieux: this.LieuxChoiceMono,
            agenceId: this.$store.state.user.agence.id,
            secId : this.$store.state.user.id,
            rdvs: this.$store.state.rdvBoite
          },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then(() => {
          this.$emit("getAllMoniteurs");
          this.$emit("cancelModal");
          //window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.data && error.response.data.errors) {
            alert(error.response.data.errors.join("\n"));
          } else if(error.response.data === "Infos manquantes"){
            alert("Infos manquantes")
          }
        });
      }

    },

    lieuChoice(e) {
      if (e.target.checked) {
        this.LieuxChoiceMono.push(e.target.id);
      } else {
        let l = this.LieuxChoiceMono.filter((li) => li != e.target.id);
        this.LieuxChoiceMono = l;
      }
    },

    groupeChoice(i) {
      this.groupeSelect = i;
      if (this.moniteurEdits != null) {
        this.lieuxMono = this.moniteur.lieux.filter((e) => e.groupe == i);
      } else {
        this.lieuxMono = this.$store.state.lieuxMonosPlanning.filter(
          (e) => e.groupe == i
        );
      }
      if(this.LieuxChoiceMono.length != 0){
        this.lieuxMono.forEach(l => {
          let i = 0;
          while(i < this.LieuxChoiceMono.length){
            if(l.id.toString() == this.LieuxChoiceMono[i]){
              l.get = true;
              break;
            }else{
              l.get = false;
              i++;
            }
          }
        })
      }
    },

    boiteChoice(e) {
      this.moniteur.boite = e.target.value;
      this.$store.commit("setChoiceBoitePlanning", e.target.value);

      if (this.moniteurEdits != null && e.target.value !== this.originalBoite) {
        window.api
          .get("/moniteur/" + this.moniteurEdits.idMono + "/check-boite", {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            if (response.data.conflict) {
              alert(response.data.message + " Veuillez annuler ces créneaux vous-même avant de changer la boîte.");
              this.moniteur.boite = this.originalBoite;
              this.$store.commit("setChoiceBoitePlanning", this.originalBoite);
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 409 && error.response.data.conflict) {
              alert(error.response.data.message + " Veuillez annuler ces créneaux vous-même avant de changer la boîte.");
              this.moniteur.boite = this.originalBoite;
              this.$store.commit("setChoiceBoitePlanning", this.originalBoite);
              return;
            }
            console.log(error);
          });
      }
    },
  },
};
</script>

<style scoped>

/* ── Layout général ── */
div.container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

div.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ── Boîte radio ── */
div.boite {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 6px;
}

div.boite label {
  font-size: 13px;
  font-weight: 600;
  color: #1a1f2e;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin: 0;
}

div.boite input[type="radio"] {
  width: 16px;
  height: 16px;
  accent-color: #3b82f6;
  cursor: pointer;
  margin: 0;
}

/* ── Champs de formulaire ── */
.field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field.mt-4 {
  margin-top: 10px !important;
}

.labelForm {
  position: static;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #94a3b8;
  pointer-events: none;
  margin-bottom: 2px;
  order: -1;
}

.field > input:focus ~ label,
input:not(:placeholder-shown) ~ label,
.field > select:focus ~ label,
select:not(:placeholder-shown) ~ label {
  top: auto;
  font-size: 11px;
}

.form-control.inputsize {
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  color: #1a1f2e;
  background: #fff;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
  width: 100%;
}

.form-control.inputsize:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,.08);
}

.form-control.inputsize::placeholder {
  color: transparent;
}

/* ── Rangées ── */
.row {
  display: flex;
  gap: 12px;
  margin: 0;
}

.row .field {
  flex: 1;
}

.row .col-lg-5,
.row .col-md-12 {
  padding: 0;
}

.offset-lg-1 {
  margin-left: 0 !important;
}

/* ── Section lieux ── */
div.choixlieu {
  display: flex;
  margin-top: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
  min-height: 200px;
}

div.groupe {
  width: 22%;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 4px;
  overflow-y: auto;
}

button.btnGroupe {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  transition: background .12s, color .12s;
}

button.btn-primary.btnGroupe {
  background: #3b82f6;
  color: #fff;
}

button.btn-secondary.btnGroupe {
  background: transparent;
  color: #64748b;
}

button.btn-secondary.btnGroupe:hover {
  background: #e2e8f0;
  color: #1a1f2e;
}

div.table {
  flex: 1;
  overflow-y: auto;
  border-left: none;
}


/* ── Bouton Valider ── */
button.btn.btn-primary {
  margin-top: 18px;
  padding: 10px 28px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background .15s, box-shadow .15s;
}

button.btn.btn-primary:hover {
  background: #2563eb;
  box-shadow: 0 4px 12px rgba(59,130,246,.3);
}

/* ── DataTable lieux ── */
:deep(.p-datatable) {
  font-size: 13px;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #f8fafc;
  color: #94a3b8;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .05em;
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  border-right: none;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #fff;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 10px 14px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #1a1f2e;
}

:deep(.p-datatable .p-datatable-tbody > tr > td input[type="checkbox"]) {
  accent-color: #3b82f6;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

</style>
